import { makeStyles } from "@material-ui/core";

// Condensed wordmark ("IM_"), for the COLLAPSED 72px rail only — the full LogoFull lockup does not fit
// there. This app has no Implement logo artwork, so the mark is built as styled text rather than an SVG
// asset.
//
// Color follows `palette.navigation.color`, not a literal white: the sidebar is a near-white panel in
// the light theme, so a hardcoded white mark would be invisible there.
const useStyles = makeStyles((theme) => ({
	root: {
		display: "block",
		fontFamily: "Arial, Helvetica, sans-serif",
		fontWeight: "bold",
		fontSize: "1.1rem",
		letterSpacing: "0.05em",
		color: theme.palette.navigation.color,
	},
}));

const LogoIcon = () => {
	const classes = useStyles();

	return <span className={classes.root}>IM_</span>;
};

export default LogoIcon;
